import redirectInterceptor from "@/interceptors/redirect_interceptor";

const getDefaultState = () => {
  return {
    voyageData: null,
    bunkerData: null,
    averageSpeedData: null,

    voyageDataLoading: true,
    voyageDataError: null,

    fetchAverageSpeedLoading: true,
    fetchAverageSpeedError: null,
  };
};

const state = getDefaultState();

const getters = {
  meanDraft(state) {
    if (state.voyageData === null) {
      return null;
    }
    else {
      return (Number(state.voyageData.DraftFwd) + Number(state.voyageData.DraftAft)) / 2;
    }
  },
  displayDisplacement(state) {
    return _displayDatum(state.voyageData, "Displacement");
  },
  displayTotalSteamTime(state) {
    return _displayDatum(state.voyageData, "totalSteamTime");
  },
  displayTotalDistRun(state) {
    try {
      return _displayDatum(state.voyageData, "totalDistRun").toFixed(2);
    } catch (error) {
      return "-";
    }
  },
  displayDepartureTime(state) {
    if (_displayDatum(state.voyageData, "departureTime") === null)
      return "-";

    try {
      const formattedDate = new Date(_displayDatum(state.voyageData, "departureTime"));
      return formattedDate.toISOString().substring(0,10);
    } catch (error) {
      return "-";
    }
  },
  displayMeanDraft(_, getters) {
    if (getters.meanDraft === null) {
      return "-";
    }
    else {
      return getters.meanDraft.toFixed(2);
    }
  },
  displayDeparturePort(state) {
    return _displayDatum(state.voyageData, "portOfDeparture");
  },
  displayArrivalPort(state) {
    return _displayDatum(state.voyageData, "portOfDest");
  },
  displayEtaNextPort(state) {
    if (_displayDatum(state.voyageData, "etaNextPort") === null)
      return "-";

    try {
      const formattedDate = new Date(_displayDatum(state.voyageData, "etaNextPort"));
      return formattedDate.toISOString().substring(0,10);
    } catch (error) {
      return "-";
    }
  },
  displayBunkerDate(state) {
    if (_displayDatum(state.voyageData, "insertDate") === null)
      return "-";

    try {
      const formattedDate = new Date(_displayDatum(state.bunkerData, "insertDate"));
      return formattedDate.toISOString().substring(0,10);
    } catch (error) {
      return "-";
    }
  },
  displayBunkerPort(state) {
    return _displayDatum(state.bunkerData, "port");
  },
  displayHfo(state) {
    return _displayDatum(state.bunkerData, "hsfoSuppliedVesselFig");
  },
  displayMgo(state) {
    return _displayDatum(state.bunkerData, "mgoSuppliedVesselFig");
  },
  displayLfo(state) {
    return _displayDatum(state.bunkerData, "lsfoSuppliedVesselFig");
  },
};

const actions = {

  async fetchVoyageData({ commit }, payload) {
    commit("SET_FETCH_VOYAGE_DATA_LOADING_STATE");

    const basicUrl = localStorage.getItem("basicUrl");
    const vesselName = payload.name;
    const date = payload.date;

    const response = await redirectInterceptor.get(
      `${basicUrl}/vesselInformation/${vesselName}/voyageData`,
      {
        params: {
          date: date
        },
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      }
    );
    if (response.status === 200) {
      commit("SET_FETCH_VOYAGE_DATA_SUCCESS_STATE", response.data);
    }
    else {
      commit("SET_FETCH_VOYAGE_DATA_ERROR_STATE");
    }
  },

  async fetchVoyageBunkerData({ commit }, payload) {
    const basicUrl = localStorage.getItem("basicUrl");
    const vesselName = payload.name;
    const date = payload.date;

    const response = await redirectInterceptor.get(
      `${basicUrl}/vesselInformation/${vesselName}/voyageBunkerData`,
      {
        params: {
          date: date
        },
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      }
    );
    if (response.status === 200) {
      commit("SET_BUNKER_DATA", response.data);
    }
  },

  async fetchVoyageAverageSpeedData({ commit }, payload) {
    const basicUrl = localStorage.getItem("basicUrl");
    const vesselName = payload.name;
    const date = payload.date;

    commit("SET_FETCH_AVERAGE_SPEED_LOADING_STATE");

    const response = await redirectInterceptor.get(
      `${basicUrl}/vesselInformation/${vesselName}/voyageAverageSpeedData`,
      {
        params: {
          date: date
        },
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      }
    );
    if (response.status === 200) {
      commit("SET_FETCH_AVERAGE_SPEED_SUCCESS_STATE", response.data);
    }
    else {
      commit("SET_FETCH_AVERAGE_SPEED_ERROR_STATE");
    }
  },
};

const mutations = {
  SET_VOYAGE_DATA: (state, data) => (state.voyageData = data),
  SET_BUNKER_DATA: (state, data) => (state.bunkerData = data),
  SET_SPEED_DATA: (state, data) => (state.averageSpeedData = data),
  SET_FETCH_VOYAGE_DATA_LOADING_STATE(state) {
    state.voyageDataLoading = true;
    state.voyageDataError = null;
  },
  SET_FETCH_VOYAGE_DATA_ERROR_STATE(state) {
    state.voyageDataLoading = false;
    state.voyageDataError = "Could not fetch voyage data";
  },
  SET_FETCH_VOYAGE_DATA_SUCCESS_STATE(state, data) {
    state.voyageDataLoading = false;
    state.voyageDataError = null;
    state.voyageData = data;
  },
  SET_FETCH_AVERAGE_SPEED_LOADING_STATE(state) {
    state.fetchAverageSpeedLoading = true;
    state.fetchAverageSpeedError = null;
  },
  SET_FETCH_AVERAGE_SPEED_ERROR_STATE(state) {
    state.fetchAverageSpeedLoading = false;
    state.fetchAverageSpeedError = "Could not fetch average speed data";
  },
  SET_FETCH_AVERAGE_SPEED_SUCCESS_STATE(state, data) {
    state.fetchAverageSpeedLoading = false;
    state.fetchAverageSpeedError = null;
    state.averageSpeedData = data;
  },
};

function _displayDatum(object, key) {
  try {
    if (object[key] === null || object[key] === undefined) {
      return "-";
    }
    else {
      return object[key];
    }
  }
  catch (error) {
    return "-";
  }
}

export const voyageModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
